<template>
  <AuthContainer>
    <template #form>
      <NhstFreeUserRegistration />
    </template>
  </AuthContainer>
</template>

<script>
import {
  NhstFreeUserRegistration,
  AuthContainer
} from '../components';
import AnonymousPage from '@pages/AnonymousPage';

export default {
  name: 'free-registration-page',
  components: {
    AuthContainer,
    NhstFreeUserRegistration
  },
  extends: AnonymousPage,

  methods: {
    getTitle() {
      return `${this.$t('registration.page.title')} | ${this.publication.title}`;
    },
    getRedirectLocation() {
      throw Error('You need to implement this yourself!');
    },
  }
};

</script>
